"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Legend_1 = require("../../../parts/Legend");
exports.default = Legend_1.Legend;
//# sourceMappingURL=Legend.js.map